// StatCard.js
import { TrendingUp, TrendingDown } from 'lucide-react';
import { DashboardIcons} from './DasboardIcons'; // Make sure to import correctly

const StatCard = ({stats, title, value, iconType, trend, color }) => {
  const Icon = DashboardIcons[iconType]; // Get the icon from the DashboardIcons object
console.log(stats)
  // Check if the icon is valid
  if (!Icon) {
    console.error('Invalid iconType:', iconType);
  }

  const isPositiveTrend = trend.includes('+');

  const colorClasses = {
    blue: 'bg-blue-50 text-blue-600',
    green: 'bg-green-50 text-green-600',
    yellow: 'bg-yellow-50 text-yellow-600',
    red: 'bg-red-50 text-red-600',
  };

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex items-center justify-between mb-4">
        <div className={`p-2 rounded-lg ${colorClasses[color]}`}>
          {Icon ? <Icon className="w-6 h-6" /> : null}  {/* Render the icon if it's valid */}
        </div>
      </div>
      <h3 className="text-gray-500 text-sm">{title}</h3>
      <div className="flex items-baseline mt-1">
        <p className="text-2xl font-semibold text-gray-900">{value}</p>
        <span
          className={`ml-2 flex items-center text-sm ${
            isPositiveTrend ? 'text-green-600' : 'text-red-600'
          }`}
        >
          {isPositiveTrend ? (
            <TrendingUp className="w-4 h-4 mr-1" />
          ) : (
            <TrendingDown className="w-4 h-4 mr-1" />
          )}
          {trend}
        </span>
      </div>
    </div>
  );
};

export default StatCard;
